<template>
  <div class="system-dic-container layout-padding">
    <el-card shadow="hover" class="layout-padding-auto">
      <div class="system-user-search mb15">
        <el-input v-model="queryData.SearchValue" @blur="queryTableData" clearable size="small" placeholder="请输入关键字查询" style="max-width: 180px">
        </el-input>
        <el-select v-model="queryData.Status" @change="queryTableData" clearable placeholder="状态" size="small">
          <el-option v-for="item in statusOption" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
        <el-select v-model="queryData.AuditStatus"  @change="queryTableData" clearable placeholder="审核状态" size="small">
          <el-option v-for="item in auditOption" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
        <el-button size="small" type="primary" class="ml10" @click="queryTableData">
          <el-icon>
            <ele-Search />
          </el-icon>
          查询
        </el-button>
        <el-button size="small" type="success" class="ml10" @click="onOpenAddDic({})">
          <el-icon>
            <ele-FolderAdd />
          </el-icon>
          新增
        </el-button>
      </div>
      <el-table :data="tableData" v-loading="loading" style="width: 100%">
        <el-table-column type="index" label="序号" width="50" />
        <el-table-column prop="ExaminationSubjects" label="科目" show-overflow-tooltip width="160"></el-table-column>
        <el-table-column prop="ExaminationTime" label="考试时间" show-overflow-tooltip ></el-table-column>
        <el-table-column prop="Name" label="姓名" show-overflow-tooltip></el-table-column>
        <el-table-column prop="Gender" label="性别" show-overflow-tooltip width="60"></el-table-column>
        <el-table-column prop="CardId" label="身份证" show-overflow-tooltip></el-table-column>
        <el-table-column prop="Phone" label="电话" show-overflow-tooltip></el-table-column>
        <el-table-column prop="Status_show" label="状态" show-overflow-tooltip>
          <template #default="scope">
            <el-tag :type="scope.row.Status_type" size="small">{{
              scope.row.Status_show
            }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="AuditStatus_show" label="审核状态" show-overflow-tooltip>
          <template #default="scope">
            <el-tag :type="scope.row.AuditStatus_type" size="small">{{
              scope.row.AuditStatus_show
            }}</el-tag>
          </template>
        </el-table-column>

        <el-table-column label="操作" width="140">
          <template #default="scope">
            <el-button v-if="scope.row.AuditStatus === 0" size="small" text type="text"
              @click="gotoAudit(scope.row)">审核</el-button>
            <el-button v-if="scope.row.AuditStatus === 0" size="small" text type="text"
              @click="gotoPreview(scope.row)">预览</el-button>
            <el-button size="small" text type="text" @click="onRowDel(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination @size-change="onHandleSizeChange" @current-change="onHandleCurrentChange" class="mt15"
        :pager-count="5" :page-sizes="[10, 20, 30]" v-model:current-page="queryData.page" background
        v-model:page-size="queryData.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total">
      </el-pagination>
    </el-card>
    <dicDialog ref="dicDialogRef" @refresh="queryTableData()"></dicDialog>
  </div>
</template>

<script>
import {
  PostSelectRecruitmentInfo,
  AuditRecruitmentInfo,
  DeleteRecruitmentInfo,
} from "@/api/RecruitmentInfo/RecruitmentInfo";
import dicDialog from "./dialog.vue";

export default {
  name: "rencaizixun",
  components: { dicDialog },
  data() {
    return {
      loading: false,
      tableData: [],
      total: 0,
      queryData: {
        page: 1,
        pageSize: 10,
        SearchValue: undefined,
        Status: undefined,
        AuditStatus: undefined,
      },
      statusOption: [
        {
          label: '待考',
          value: 0
        },
        {
          label: '已考',
          value: 1
        },
        // {
        //   label: '全部',
        //   value: undefined
        // },
      ],
      auditOption: [
        {
          label: '未审核',
          value: 0
        },
        {
          label: '已通过',
          value: 1
        },
        {
          label: '未通过',
          value: 2
        },
      ]
    };
  },
  methods: {
    onRowDel(row) {
      let that = this;
      this.$confirm("是否删除该数据？", "提示", {}).then(() => {
        that.HttpDelSysDic({ id: row.Id });
      });
    },
    onOpenAddDic(row) {
      this.$refs.dicDialogRef.openDialog(row, "add");
    },
    gotoPreview(row) {
      this.$refs.dicDialogRef.openDialog(row, "preview");
    },
    gotoAudit(row) {
      let that = this;
      this.$confirm("是否审核通过该数据？", "提示", {}).then(() => {
        that.HttpAuditUser({ id: row.Id });
      });
    },
    queryTableData() {
      let param = {
        ... this.queryData,
        page: this.queryData.page,
        intPageSize: this.queryData.pageSize,
      };
      this.HttpQueryBlogList(param);
    },
    onHandleSizeChange(val) {
      this.queryData.pageSize = val;
      this.queryTableData();
    },
    onHandleCurrentChange(val) {
      this.queryData.page = val;
      this.queryTableData();
    },
    //Http查询列表数据
    async HttpQueryBlogList(param) {
      this.loading = true;
      const res = await PostSelectRecruitmentInfo(param);
      this.loading = false;
      if (res.data.status == 200) {
        let raw = res.data.response;
        let statusDic = {
          0: {
            label: "待考",
            type: "warning",
          },
          1: {
            label: "已考",
            type: "success",
          },
        };
        let AuditDic = {
          0: {
            label: "未审核",
            type: "info",
          },
          1: {
            label: "已通过",
            type: "success",
          },
          2: {
            label: "未通过",
            type: "danger",
          },
        };
        this.total = raw.dataCount;
        let list = raw.data || [];
        list.forEach((o) => {
          o.Status_show = statusDic[o.Status].label;
          o.Status_type = statusDic[o.Status].type;
          o.AuditStatus_show = AuditDic[o.AuditStatus].label;
          o.AuditStatus_type = AuditDic[o.AuditStatus].type;
        });
        this.tableData = raw.data;
      } else {
        this.$message.error(res.data.msg);
      }
    },
    async HttpAuditUser(param) {
      const response = await AuditRecruitmentInfo(param);
      let res = response.data || {};
      if (res.status == 200) {
        this.queryTableData();
        this.$message({
          message: "操作成功",
          type: "success",
        });
      } else {
        this.$message({
          message: res.msg,
          type: "error",
        });
      }
    },
    async HttpDelSysDic(param) {
      const response = await DeleteRecruitmentInfo(param);
      let res = response.data || {};
      if (res.status == 200) {
        this.queryTableData();
        this.$message({
          message: "操作成功",
          type: "success",
        });
      } else {
        this.$message({
          message: res.msg,
          type: "error",
        });
      }
    },
  },

  mounted() {
    this.queryTableData();
  },
};
</script>

<style scoped></style>